import { render, staticRenderFns } from "./wallet.vue?vue&type=template&id=9fa250b4&scoped=true"
import script from "./wallet.vue?vue&type=script&lang=js"
export * from "./wallet.vue?vue&type=script&lang=js"
import style0 from "./wallet.vue?vue&type=style&index=0&id=9fa250b4&prod&lang=less&scoped=true"
import style1 from "./wallet.vue?vue&type=style&index=1&id=9fa250b4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fa250b4",
  null
  
)

export default component.exports